export const STORAGE_RETURN_FORM_KEY = 'RETURN_FORM';
export var StepRoutes;
(function (StepRoutes) {
    StepRoutes["ORDER_STEP"] = "order";
    StepRoutes["PACKAGE_STEP"] = "package";
    StepRoutes["SELECT_ITEMS_STEP"] = "select-items";
    StepRoutes["SHIPPING_STEP"] = "shipping";
    StepRoutes["END_STEP_SUCCESS"] = "success";
    StepRoutes["END_STEP_FAIL"] = "fail";
})(StepRoutes || (StepRoutes = {}));
export const stepsOrder = [
    StepRoutes.ORDER_STEP,
    StepRoutes.PACKAGE_STEP,
    StepRoutes.SELECT_ITEMS_STEP,
    StepRoutes.SHIPPING_STEP,
];
export var FormikFields;
(function (FormikFields) {
    // ORDER_STEP
    FormikFields["ORDER_NUMBER"] = "ORDER_NUMBER";
    FormikFields["EMAIL_ADDRESS"] = "EMAIL_ADDRESS";
    // PACKAGE_STEP
    FormikFields["PARCEL_NUMBER"] = "PARCEL_NUMBER";
    FormikFields["PICK_UP_DATE"] = "PICK_UP_DATE";
    FormikFields["ADDRESS"] = "ADDRESS";
    FormikFields["POSTAL_CODE"] = "POSTAL_CODE";
    FormikFields["PLACE_CODE"] = "PLACE_CODE";
    // SELECT_ITEMS_STEP
    FormikFields["RETURN_REASON_CODE"] = "returnReasonCode";
    FormikFields["RETURN_REASON_TEXT"] = "returnReasonText";
    FormikFields["RETURN_REASON_OTHER"] = "returnReasonOther";
    FormikFields["RETURN_QUANTITY"] = "returnQuantity";
})(FormikFields || (FormikFields = {}));
export var FormReturnType;
(function (FormReturnType) {
    FormReturnType["COLLECTION"] = "collection";
    FormReturnType["CONSIGNMENT"] = "consignment";
})(FormReturnType || (FormReturnType = {}));
export const PDF_FILE_NAME = 'return_order';
export const OTHER_REASON_CODE = 5;
